<mat-card appearance="outlined" class="o100w-moneybar-config-card">
  <mat-card-header>
    <mat-card-title>
      Moneybar{{ currentMoneybar ? ' (' + currentMoneybar.beneficiaryGroup.code + ')' : '' }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <app-moneybar [moneybarData]="currentMoneybar"></app-moneybar>

    <form [formGroup]="editForm">
      <ng-container *ngxPermissionsOnly="rolesToEdit">
        @for (setting of settings; track setting) {
          <mat-form-field>
            <mat-label>{{ settingDisplayFn(setting) }}</mat-label>
            <input id="setting-moneybar-{{ setting.code }}" matInput required [formControlName]="setting.code" />
          </mat-form-field>
        }
      </ng-container>
    </form>
  </mat-card-content>

  <mat-card-actions>
    <button mat-button type="button" (click)="back()">Back</button>
    <button
      mat-raised-button
      color="primary"
      (click)="save()"
      [disabled]="!editForm.valid"
      *ngxPermissionsOnly="rolesToEdit"
    >
      Save
    </button>
  </mat-card-actions>
</mat-card>

<mat-card appearance="outlined" class="o100w-groups-ready-for-donations-card">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>Moneybar group association</mat-card-title>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    @if (!isProd) {
      <mat-form-field>
        <mat-label>Show moneybars for date:</mat-label>
        <input
          name="100w-moneybar-config-timetravel-date"
          matInput
          (dateChange)="moneybarTimeTravelTo($event)"
          [matDatepicker]="timeTravelDatePicker"
        />
        <mat-datepicker-toggle matSuffix [for]="timeTravelDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #timeTravelDatePicker></mat-datepicker>
      </mat-form-field>
    }
    @if (noMoneybarsConfigured) {
      <span class="o100w-info-text o100w-info-text--warn"
        >There is no group ready to receive donations; new donations will not be linked to a group!</span
      >
    }
    @if (groupsReadyForDonations && groupsReadyForDonations.length) {
      <div
        class="o100w-groups-ready-for-donations"
        cdkDropList
        (cdkDropListDropped)="updateGroupReadyForDonationsSequence($event)"
        appSpinnerOverlay
        [showSpinner]="showSpinner$"
      >
        <span class="o100w-groups-ready-for-donations-subheader">Group currently associated to moneybar</span>
        <app-draggable
          [cdkDragData]="groupsReadyForDonations[0]"
          index="M"
          [showDelete]="false"
          [label]="beneficiaryGroupDisplayFn(groupsReadyForDonations[0])"
          color="accent"
          (delete)="unsetGroupReadyForDonations($event)"
        >
          <app-moneybar-container
            class="moneybar-container"
            color="accent"
            [beneficiaryGroupUuid]="groupsReadyForDonations[0].uuid"
            [timeTravelDate]="moneybarTimeTravelDate"
          >
          </app-moneybar-container>
        </app-draggable>
        <app-moneybar-legend></app-moneybar-legend>
        <span class="o100w-groups-ready-for-donations-subheader">Next up</span>
        @for (group of groupsReadyForDonations; track group; let isFirst = $first; let index = $index) {
          @if (!isFirst) {
            <app-draggable
              [cdkDragData]="group"
              [index]="index"
              [label]="beneficiaryGroupDisplayFn(group)"
              color="grey"
              (delete)="unsetGroupReadyForDonations($event)"
            >
              @if (!isFirst) {
                <app-moneybar-container
                  class="moneybar-container"
                  [beneficiaryGroupUuid]="group.uuid"
                  [timeTravelDate]="moneybarTimeTravelDate"
                  color="grey"
                >
                </app-moneybar-container>
              }
            </app-draggable>
          }
        }
      </div>
    }

    <div class="o100w-groups-ready-for-donations-add" *ngxPermissionsOnly="rolesToEdit">
      <app-group-autocomplete
        flLabel="Select group"
        [modelList]="groupsNotReadyForDonations"
        [formControl]="setGroupReadyForDonationsControl"
        [customDisplay]="beneficiaryGroupDisplayFn"
        [customSort]="beneficiaryGroupSortFn"
      >
      </app-group-autocomplete>
      <mat-card-actions>
        <button
          mat-raised-button
          type="button"
          color="primary"
          [disabled]="!setGroupReadyForDonationsControl.value"
          (click)="setGroupReadyForDonations()"
        >
          Add group to list
        </button>
        <button mat-button type="button" color="primary" (click)="createNewGroup()">Create new group</button>
      </mat-card-actions>
    </div>
  </mat-card-content>
</mat-card>

<mat-card appearance="outlined" class="o100w-no-scroll">
  <mat-card-header>
    <mat-card-title>Total funding</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-list class="o100w-info-block-list">
      @for (item of totalFunding | keyvalue; track item) {
        <mat-list-item class="o100w-info-block">
          <h4 matListItemTitle>{{ item.key }}</h4>
          <p matListItemLine>
            <span>{{ item.value }}</span>
          </p>
        </mat-list-item>
      }
    </mat-list>
  </mat-card-content>
</mat-card>
